import { useQuery } from "@tanstack/react-query";
import { PurchaseOrderService } from "src/services";
import { queryKeys } from "src/constants";
import { CreatedAtDateTimeRange, POCompletionStatus } from "src/types";

const usePurchaseOrderIds = (
  purchaseOrderService: PurchaseOrderService,
  completionStatus: POCompletionStatus | POCompletionStatus[],
  dateTimeRange?: CreatedAtDateTimeRange
) => {
  const {
    data: purchaseOrderIds,
    error: fetchError,
    isLoading,
    refetch
  } = useQuery({
    queryKey: queryKeys.purchaseOrderIds(completionStatus, dateTimeRange),
    queryFn: () => purchaseOrderService.getPurchaseOrderIds(completionStatus, dateTimeRange)
  });

  return { purchaseOrderIds, fetchError, isLoading, refetch };
};

export { usePurchaseOrderIds };
